import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

// Native date pickers only open from their small icon; open them on any click
// inside the field so dates can be chosen without typing.
document.addEventListener("click", (event) => {
  const target = event.target;
  if (
    target instanceof HTMLInputElement &&
    ["date", "month", "datetime-local"].includes(target.type) &&
    !target.disabled &&
    !target.readOnly
  ) {
    try {
      target.showPicker();
    } catch {
      // showPicker may be unavailable or blocked; the field still accepts typing.
    }
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
